document.addEventListener('DOMContentLoaded', function () {
    initializeMobileMenu();

    function initializeMobileMenu() {
        const offCanvasBtn = document.getElementById('off-canvas-btn');
        const mobileMenu = document.getElementById('mobile-menu');
        const mobileMenuClose = document.getElementById('mobile-menu-close');
        const menuLinks = document.querySelectorAll('#mobile-menu-nav a');

        if (!offCanvasBtn || !mobileMenu || !mobileMenuClose) {
            return;
        }

        function openMenu() {
            mobileMenu.classList.add('open-menu');
        }

        function closeMenu() {
            mobileMenu.classList.remove('open-menu');
        }

        offCanvasBtn.addEventListener('click', openMenu);
        mobileMenuClose.addEventListener('click', closeMenu);

        // Close menu when clicking on links
        menuLinks.forEach(link => {
            link.addEventListener('click', closeMenu);
        });

        // Close menu when clicking outside its area
        window.addEventListener('click', function(event) {
            if (!mobileMenu.contains(event.target) && !offCanvasBtn.contains(event.target)) {
                closeMenu();
            }
        });
    }

    // Popup Adult Warning
    function setCookie(name, value, days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        document.cookie = `${name}=${value};expires=${date.toUTCString()};path=/`;
    }

    function getCookie(name) {
        const cookies = document.cookie.split(';');
        for (let cookie of cookies) {
            const [key, value] = cookie.trim().split('=');
            if (key === name) return value;
        }
        return null;
    }

    function acceptAdult() {
        setCookie("popup_18_hidden", "true", 30);
        document.getElementById('popup').style.display = 'none';
        document.getElementById('page').classList.remove('blurred');
    }

    function showUnderagePopup() {
        document.getElementById('popup').style.display = 'none';
        document.getElementById('underage-popup').style.display = 'flex';
    }

    window.onload = function () {
        if (!getCookie("popup_18_hidden")) {
            document.getElementById('popup').style.display = 'flex';
            document.getElementById('page').classList.add('blurred');
        }

        document.getElementById('yesButton').addEventListener('click', acceptAdult);
        document.getElementById('noButton').addEventListener('click', showUnderagePopup);
    };
});

function smoothScrollLinks() {
    let isHomePage = document.body.classList.contains('home');

    document.querySelectorAll('.js-play').forEach(link => {
        link.addEventListener('click', function (event) {
            let id = this.getAttribute('data-href') || this.getAttribute('href');
            let targetUrl = new URL(window.location.origin + id);

            if (isHomePage) {
                let targetElement = document.querySelector(id);
                if (targetElement) {
                    event.preventDefault();
                    let menuHeight = document.getElementById('masthead')?.offsetHeight || 0;
                    let top = targetElement.offsetTop - menuHeight;
                    window.scrollTo({ top: top, behavior: 'smooth' });
                }
            } else {
                event.preventDefault();
                window.location.href = `/${id}`;
            }
        });
    });
}

jQuery(document).ready(function ($) {
    $('#contact-form').on('submit', function (e) {
        e.preventDefault();
        $('#popup-thank-you').fadeIn(300);

        setTimeout(function () {
            $('#popup-thank-you').fadeOut(300);
        }, 5000);

        $('#contact-form')[0].reset();
    });
});